import styled from 'styled-components';
import { Flex, FlexProps, rem } from '@mantine/core';

type DashboardSidePanelContainerProps = {
	$isSidePanelOpen: boolean;
	$width: number | string;
	$isResizing: boolean;
	$allowResizing?: boolean;
	$side: 'left' | 'right';
};
export const DashboardSidePanelContainer = styled.div<DashboardSidePanelContainerProps>`
	position: relative;
	min-width: ${(props) => (props.$isSidePanelOpen ? `${props.$width}` : '0px')};
	max-width: ${(props) => (props.$isSidePanelOpen ? `${props.$width}` : '0px')};
	overflow-x: hidden;
	overflow-y: auto;
	${(props) =>
		props.$side === 'left'
			? `border-right: 1px solid ${props.theme.v3.colors.gray[4]};`
			: `border-left: ${props.children ? 1 : 0}px solid ${props.theme.v3.colors.gray[4]};`}

	visibility: ${(props) => (props.$isSidePanelOpen ? 'visible' : 'hidden')};

	transition: ${(props) =>
		props.$isResizing
			? 'none'
			: 'visibility 0.3s, opacity 0.3s ease-in-out, min-width 0.3s ease-in-out, max-width 0.3s ease-in-out'};

	${({ $allowResizing }) =>
		$allowResizing
			? `&::after {
		content: '';
		position: absolute;
		right: -4px;
		top: 0;
		width: 8px;
		height: 100%;
		cursor: col-resize;}`
			: ''}
`;

type SidePanelResizerProps = {
	side: 'left' | 'right';
};
export const SidePanelResizer = styled.div<SidePanelResizerProps>`
	position: absolute;
	${(props) => (props.side === 'left' ? 'right: 0;' : 'left: 0;')}
	top: 0;
	bottom: 0;
	width: 8px;
	cursor: col-resize;
	background-color: transparent;
	z-index: 10;
	touch-action: none;
`;

export const DashboardBodyContainer = styled(Flex).attrs((props: FlexProps) => props)`
	height: 100%;
	border: 1px solid ${(props) => props.theme.v3.colors.gray[4]};
	border-radius: ${rem(4)};
	overflow: hidden;
`;
